/**
 * Adapter to use handlebars in the $tpl method
 * @param handlebars either the result require('handlebars/dist/handlebars.js');
 *                  or "Handlebars" if you use: import * as Handlebars from 'handlebars/dist/handlebars'
 *                  depending on your build setup
 * @param options additional handlebars compiler options
 */
export function tplAdapterHandlebars(handlebars, options) {
    var compiled = new Map();
    if (!handlebars || !handlebars.compile)
        throw new Error('Invalid handlebars implementation given!');
    return function (template, data, hash) {
        if (!compiled.has(hash)) {
            compiled.set(hash, handlebars.compile(template, options !== null && options !== void 0 ? options : {}));
        }
        return compiled.get(hash)(data);
    };
}
//# sourceMappingURL=tplAdapterHandlebars.js.map